export enum Countries{
  Afghanistan = "Afghanistan",
  Albania = "Albania",
  Algeria =  "Algeria",
  Argentina = "Argentina",
  Australia = "Australia",
  Austria = "Austria",
  Bahamia = "Bahamia",
  Bahrain = "Bahrain",
  Bangladesh = "Bangladesh",
  Barbados = "Barbados",
  Belize="Belize",
  Bermuda ="Bermuda",
  Bhuta = "Bhuta",
  Bolivia = "Bolivia",
  Botswana = "Botswana",
  Brazil ="Brazil",
  Burundi = "Burundi",
  Cambodia ="Cambodia",
  Canada = "Canada",
  CapeVerde ="Cape Verde",
  CaymanIslands  ="Cayman Islands",
  Chile= "Chile",
  China= "China",
  Colombia= "Colombia",
  ComorosIsland= "Comoros Island",
  CostaRica= "Costa Rica",
  Croatia = "Croatia",
  Cuba = "Cuba",
  Cyprus= "Cyprus",
  CzechRepublic= "Czech Republic",
  Denmark= "Denmark",
  Dijibouti= "Dijibouti",
  DominicanRepublic= "Dominican Republic",
  EastCaribbean= "East Caribbean",
  Egypt= "Egypt",
  //  ",El Salvador",El Salvador
  Estonia= "Estonia",
  Ethiopia= "Ethiopia",
  //  ",Falkland Islands",Falkland Islands
  Gambia= "Gambia",
  Ghana= "Ghana",
  //  ",Gibraltar"Afghanistan
  //  ",Guatemala"Afghanistan
  GuineaBissau ="Guinea Bissau",
  Guyana = "Guyana",
  Haiti = "Haiti",
  Honduras = "Honduras",
  HongKong = "Hong Kong",
  Hungary = "Hungary",
  Iceland= "Iceland",
  India= "India",
  Indonesia= "Indonesia",
  Iraq ="Iraq",
  Israel ="Israel",
  Jamaica="Jamaica",
  Japan="Japan",
  Jordan= "Jordan",
  Kazakhstan= "Kazakhstan",
  Kenya="Kenya",
  Korea= "Korea",
  Kuwait = "Kuwait",
  Macedonia="Macedonia",
  Malawi="Malawi",
  Malaysia="Malaysia",
  Maldives="Maldives",
  Malta="Malta",
  Mauritania="Mauritania",
  Mauritius="Mauritius",
  Mexico="Mexico",
  //  "Moldova"Moldova
  //  "Mongolia"Mongolia
  Morocco="Morocco",
  //  "Mozambique"Mozambique
  //  "Myanmar"Myanmar
  Namibia="Namibia",
  Nepal="Nepal",
  NewZealand ="New Zealand",
  Nicaragua="Nicaragua",
  Nigeria="Nigeria",
  NorthKorea="North Korea",
  //  "Norwegia"Norwegia
  //  "Oman"Oman
  Pacific= "Pacific",
  Pakistan="Pakistan",
  //  "Panama"Panama
  //  "Papua New Guinea"Papua New Guinea
  Paraguay= "Paraguay",
  Peru= "Peru",
  Philippines= "Philippines",
  Poland="Poland",
  Qatar="Qatar",
  Romania="Romania",
  Russia="Russia",
  //  "Samoa"Samoa
  //  "Sao Tome and Principe"Sao Tome and Principe
  //  "Saudi Arabia"Saudi Arabia
  //  "Seychelles"Seychelles
  SierraLeone= "Sierra Leone",
  Singapore="Singapore",
  //  "Slovakia"Slovakia
  //  "Slovenia"Slovenia
  //  "Solomon Islands"Solomon Islands
  Somalia="Somalia",
  SouthAfrica="South Africa",
  SriLanka= "Sri Lanka",
  Sudan="Sudan",
  Swaziland= "Swaziland",
  Sweden= "Sweden",
  Switzerland="Switzerland",
  Syria="Syria",
  Taiwan="Taiwan",
  Tanzania="Tanzania",
  Thailand="Thailand",
  Turkey="Turkey",
  Ukraine="Ukraine",
  Uruguay="Uruguay",
  UnitedKindgom="United Kindgom",
  UnitedStates="United States",
  Venezuela="Venezuela",
  Vietnam="Vietnam",
  Yemen="Yemen",
  Zambia="Zambia",
  Zimbabwe="Zimbabwe"

}
